<h5 mat-dialog-title>Report Parameters &mdash; {{ reportName }}</h5>

<mat-dialog-content [formGroup]="form">
    <div class="parameter-field" *ngFor="let parameter of parameters">

        <mat-checkbox *ngIf="parameter.type === 'Boolean'" [formControlName]="parameter.controlName">
            {{ parameter.text }}
        </mat-checkbox>

        <mat-form-field *ngIf="parameter.type !== 'Boolean'" appearance="outline" class="parameter-form-field">
            <mat-label>{{ parameter.text }}</mat-label>

            <mat-select *ngIf="parameter.availableValues?.length"
                        [formControlName]="parameter.controlName"
                        [multiple]="parameter.multiValue">
                <mat-option *ngFor="let value of parameter.availableValues" [value]="value">
                    {{ value }}
                </mat-option>
            </mat-select>

            <input *ngIf="!parameter.availableValues?.length && parameter.type === 'DateTime'"
                   matInput
                   [matDatepicker]="picker"
                   [formControlName]="parameter.controlName">
            <mat-datepicker-toggle *ngIf="!parameter.availableValues?.length && parameter.type === 'DateTime'" matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>

            <input *ngIf="!parameter.availableValues?.length && (parameter.type === 'Integer' || parameter.type === 'Float')"
                   matInput
                   type="number"
                   [formControlName]="parameter.controlName">

            <input *ngIf="!parameter.availableValues?.length && parameter.type === 'String'"
                   matInput
                   [formControlName]="parameter.controlName">

            <mat-error *ngIf="form.get(parameter.controlName)?.hasError('required')">
                {{ parameter.text }} is required
            </mat-error>
        </mat-form-field>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="mat-raised-button" appPreventDoubleClick (throttledClick)="close()">Cancel</button>

    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="run()">
        Run Report
    </button>
</mat-dialog-actions>
